import { Image, Ico, Text, View } from 'components';
import Base, { Config } from 'components/trunk/Base';
import React from 'react';
import { history } from 'modules/navigator';
import styles from './index.module.scss';


const LEVEL_SILVER = 1
const LEVEL_GOLD = 2
const LEVEL_KING = 3   //2022-05-18 新增



interface State {
  vipList: {
    days: number
    id: number
    info_list: any
    level: number   //1：银会员；   2：金会员  3皇冠会员
    // type: number    //1长期；  2替班
    name: string
    price: string
    cost: string
    status: number
  }[]
  currentLevel: 1 | 2  //当前选中的
  vipInfo: any,
  ticketInfo?: any
}

export default class VipCompaire extends Base<any, State> {
  public config: Config = {
    navigationBarTitleText: '会员特权'
  };

  public state: State = {
    vipList: [],
    currentLevel: LEVEL_GOLD,
    vipInfo: {},
  };

  public async didMount() {
    // await this.getUserInfo();
    const params:any = this.navigator.getParams(' '+this.props.location.search) || {}
    const col = (this.props.location.state || {})
    this.setState({
      // type: params.type || col || 1,
      currentLevel: params.level || LEVEL_GOLD
    })


    this.init(params)
  }

  public render() {
    const { currentLevel, vipInfo, vipList, ticketInfo } = this.state;

    return vipList.length > 0? (
      <View className={styles.container}>
        
        <View className={styles.page} style={vipList.length == 0? {display: 'none'}: {}}>
         
         
          

          <View className={styles.lists}>

            
          <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'flatCall') || {}).status
            })} onClick={() => {
              return;
            }}>
              <View className={styles.icoBox}><Ico src={this.assets.trunk.vipIcon1} size={41} /></View>
              <View className={styles.mid}>
                {(this.vipSelectedInfo.find(e => e.column == 'flatCall') || {}).value? (
                  <View className={styles.p}>
                    <Text>
                      每天查看
                      <Text className={styles.red}>{(this.vipSelectedInfo.find(e => e.column == 'flatCall') || {}).value || ''}条</Text>
                      货源信息
                    </Text>
                  </View>
                ): (
                  <View className={styles.p}>
                    <Text>项目电话{this.vipSelected.level}年内免费拨打</Text>
                  </View>
                )}
              </View>
            </View>
            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'push') || {}).status
            })} onClick={this.handleGotoIntroduce.bind(null, 'trunk_push')}>
              <View className={styles.icoBox}><Ico src={this.assets.trunk.vipIcon2} size={30} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  <Text>板车名录和设备<Text className={styles.red}>同时优先展示</Text></Text>
                </View>
              </View>
              <Text className={styles.rig}>{'介绍>>'}</Text>
            </View>
            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'law') || {}).status
            })}>
              <View className={styles.icoBox}><Ico src={this.assets.trunk.vipIcon3} size={41} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  律师在线法务咨询
                  <View className={styles.tag}>
                    （价值{(this.vipSelectedInfo.find(e => e.column == 'law') || {}).price || ''}元）
                  </View>
                </View>
              </View>
            </View>
            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'remind') || {}).status
            })}>
              <View className={styles.icoBox}><Ico src={this.assets.trunk.vipIcon4} size={39} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  最新货源播报提醒
                  <View className={this.cx(styles.tag, styles.red)}>
                    （送{(this.vipSelectedInfo.find(e => e.column == 'remind') || {}).value || ''}条短信手机提醒）
                  </View>
                </View>
              </View>
            </View>
            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'shop') || {}).status
            })}>
              <View className={styles.icoBox}><Ico src={this.assets.trunk.vipIcon5} size={37} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  专属会员定制店铺
                </View>
              </View>
            </View>
            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'icon') || {}).status
            })} onClick={this.handleGotoIntroduce.bind(null, 'trunk_icon')}>
              <View className={styles.icoBox}><Ico src={this.assets.trunk.vipIcon6} size={45} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  专属钻石会员标识
                </View>
              </View>
              <Text className={styles.rig}>{'介绍>>'}</Text>
            </View>
            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'detail') || {}).status
            })}>
              <View className={styles.icoBox}><Ico src={this.assets.trunk.vipIcon7} size={40} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  看货物信息
                </View>
              </View>
            </View>
            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'credit') || {}).status
            })}>
              <View className={styles.icoBox}><Ico src={this.assets.trunk.vipIcon8} size={36} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  查客户信用
                </View>
              </View>
            </View>
            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'customer') || {}).status
            })} onClick={() => {
              // window.location.href = currentLevel == LEVEL_SILVER? 
              // "https://mp.weixin.qq.com/s/Aoo57KJOw6Y1eE6E4aN2vA":
              // "https://mp.weixin.qq.com/s/RtVk3VAiy-kvBVL7oWohPA"
            }}>
              <View className={styles.icoBox}><Ico src={this.assets.trunk.vipIcon9} size={37} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  VIP专属客服
                </View>
              </View>
            </View>














            
          </View>




          
          
          
            <View className={styles.fixedBtm}>
              <View className={styles.btnOuter}>
                <View className={styles.le}>
                  <Text className={styles.p}>
                    {this.vipSelected.name}
                    <Text className={styles.sm}>¥</Text>
                    {this.currentPrice}
                  </Text>
                  {(ticketInfo && ticketInfo.can_use) &&
                    <Text className={styles.origPrice}>原价：{this.vipSelected.price}元</Text>
                  }
                </View>
                <View className={styles.ri} onClick={() => {
                  this.handlePay(this.vipSelected.id)
                }}>
                  <Text>确认支付</Text>
                </View>
              </View>
            </View>
          
        </View>

      </View>
    ): '';
  }

  private get vipKing() {
    const { vipList } = this.state
    let res:any = vipList.find(e => e.level == LEVEL_KING) || {}
    return {...res, alias: '皇冠', 
      defaultIco: this.assets.rent.crownG,
      activeIco: this.assets.rent.crownB
    }
  }
  private get vipGold() {
    const { vipList } = this.state
    let res:any = vipList.find(e => e.level == LEVEL_GOLD) || {}
    return {...res, alias: '金钻', 
      defaultIco: this.assets.rent.diamondG,
      activeIco: this.assets.rent.diamondB
    }
  }
  private get vipSilver() {
    const { vipList } = this.state
    let res:any =  vipList.find(e => e.level == LEVEL_SILVER) || {}
    return {...res, alias: '银钻', 
      defaultIco: this.assets.rent.diamondG,
      activeIco: this.assets.rent.diamondB
    }
  }
  private get vipSelected() {
    const { vipList, currentLevel } = this.state
    let res:any =  vipList.find(e => e.level == currentLevel) || {}
    return res
  }
  private get vipSelectedInfo() {
    return this.vipSelected? this.vipSelected.info_list || []: []
  }

  private get currentPrice() {
    const { ticketInfo } = this.state;
    if(ticketInfo && ticketInfo.can_use) {
      const res = Number(this.vipSelected.price) - Number(ticketInfo.value);
      return res > 0? res: 0;
    }else {
      return this.vipSelected.price;
    }
  }

  
  private handleGotoIntroduce = (column:string) => {
    // this.navigator.push('vipWebview', {
    //   type: "introduce",
    //   column
    // })
    this.navigator.push('help', {type: column})
  }
  // private handleGotoRights = (column:string) => {
  //   //前往会员特权介绍页面；
  //   const { currentLevel } = this.state
  //   this.navigator.push('rentVipRights', {level: currentLevel, column: column})
  // }

  








  private handleBack = () => {
    
      this.navigator.back()
    
  }

  private handleClickPay = (obj) => {
    this.setState({
      currentLevel: obj.level
    })
    
    
      this.handlePay(obj.id)
    
  }

  private handlePay = async (id) => {
    const mob = await this.store.user.requireMobile()
    if(!mob) {
      return;
    }
    
    const response = await this.apiClient.base.vipPlusBuy({
      id
    });

    const paymentConfig = {
      appId: response.body.appId,
      nonceStr: response.body.nonceStr,
      package: response.body.package,
      paySign: response.body.paySign,
      signType: response.body.signType,
      timestamp: response.body.timeStamp
    };

    this.interface.requestPayment(paymentConfig).then(res => {
      if (res.errMsg === 'chooseWXPay:ok') {
        alert('购买成功');

      }
    });
  }


  private getUserInfo = async () => {
    // const { body } = await this.apiClient.base.userinfo();

    // const res = await this.apiClient.base.vipPlusInfo()
    // this.setState({
    //   vipInfo: body
    // })
  }

  private getMyTicket = async() => {

    const { status, body, msg } = await this.apiClient.base.awardGet({})
    if(status == 10000) {
      const it = (body || [])[0];
      this.setState({
        ticketInfo: it || {}
      }, () => {
        // if(it && it.can_use) {
        //   this.countDown()
        // }
      })
    }
  }

  private getVipLists = async() => {
    const { body } = await this.apiClient.base.vipPlus({})
    if(body) {
      this.setState({
        vipList: body || []
      })
    }
  }  

  private init = async (params) => {
    // this.getVipLists(); return; //测试
    const { body } = await this.apiClient.base.userinfo();

    // this.setState({
    //   userinfo:body
    // })
    // this.setState({
    //   userinfo: {"id":2,"nickname":"\u6211\u8ba4\u8bc6\u4f60","realname":"","mobile":"15267286145","mobile_location":"\u6d59\u6c5f\u53f0\u5dde(\u79fb\u52a8)","avatar":"https:\/\/assets.gongji58.com\/2019-02-27\/clavmj717r1551257843.png!medium","sex":1,"type":1,"reg_ip":"223.104.246.162","point":0,"id_number":"","address":"","address_id":null,"description":"","store_name":"\u6211\u8ba4\u8bc6\u4f60","store_description":"\u6d4b\u8bd5\u4e2a\u5443\u5443\u5443","car_total":54,"want_total":3,"job_total":12,"resume_total":11,"report_total":1,"last_login":"2021-06-11 11:40:54","ban_desc":"","developer":1,"status":3,"ctime":"2019-02-27 16:57:23","utime":"2020-09-15 11:38:48","is_manager":true,"id_checks":false,"pub_total":0}
    // })

    if(!body) {
      return false;
    }
    const mob = await this.store.user.requireMobile()
    if(!mob) {
      return;
    }

    this.getMyTicket()

    // if(params.mode == 'ignoreArea') {
    //   this.getVipLists();
    //   console.log('ignoreArea');
    //   return;
    // }
    
    // if(body && body.area_ban) {
    //   //判断手机号归属地是否在禁止城市
    //   alert('功能升级中！')
    //   return false;
    // }else {
      this.getVipLists()
    // }

    
  }
  
}
